import { Tabs } from '@mantine/core';
import * as React from 'react';
import { ProjectUserGroupsPageTab } from './ProjectUserGroupsPageTab';
import { ProjectUserRolesPageTab } from './ProjectUserRolesPageTab';
import { useParams } from 'react-router-dom';

export const ProjectUserManagementPage = () => {
    const [tabValue, setTabValue] = React.useState<string | null>('projectUserGroups');

    const { id: projectId } = useParams<{ id: string }>();

    return (
        <div className={'main-window-content'}>
            <Tabs value={tabValue} onChange={setTabValue}>
                <Tabs.List>
                    <Tabs.Tab value={'projectUserGroups'}>Project User Groups</Tabs.Tab>
                    <Tabs.Tab value={'projectUserRoles'}>Project User Roles</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value={'projectUserGroups'}>
                    <ProjectUserGroupsPageTab projectId={projectId ?? ""} />
                </Tabs.Panel>
                <Tabs.Panel value={'projectUserRoles'}>
                    <ProjectUserRolesPageTab projectId={projectId ?? ""} />
                </Tabs.Panel>
            </Tabs>
        </div>
    );
};


